import LegalLayout from '../components/LegalLayout';
import { COMPANY, LEGAL_UPDATED_TERMS } from '../constants/legal';

/**
 * Standard withdrawal form pursuant to Article L221-18 and Annex I of
 * the French Consumer Code (Code de la consommation). Consumers may
 * complete this form and return it by email to exercise their 14-day
 * right of withdrawal.
 *
 * A user can print this page directly (Ctrl/Cmd + P) for a paper trail.
 */
const WithdrawalFormPage = () => (
  <LegalLayout
    testId="withdrawal-form-page"
    title="Withdrawal Form — Formulaire de rétractation"
    description="Standard withdrawal form for consumer clients of Gate 33. Fill in, print or email to exercise your 14-day right of withdrawal."
    path="/legal/withdrawal-form"
    updated={LEGAL_UPDATED_TERMS}
  >
    <p className="text-lg text-[#1A1A1A] leading-relaxed mb-8">
      Only complete and return this form if you wish to withdraw from your contract with {COMPANY.tradingName}. This form is provided pursuant to Article L221-18 and Annex I of the French Consumer Code (Code de la consommation).
    </p>

    <p className="mb-8 text-sm text-[#5A5A5A]">
      You can print this page (<kbd>Ctrl/Cmd + P</kbd>), fill it in by hand, and email a scan or photo to <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Or copy the text below into an email and complete the fields directly.
    </p>

    <div className="border-2 border-[#0F0F0F] p-8 bg-white text-[#0F0F0F] whitespace-pre-line" data-testid="withdrawal-form-body">
{`To: ${COMPANY.legalName} (Gate 33)
Email: ${COMPANY.email}

I / We (*) hereby give notice that I / We (*) withdraw from my / our (*) contract for the provision of the following service:

Service ordered: ________________________________________
(e.g. Gate 33 3-Day Online Training — cohort of dd/mm/yyyy)

Ordered on: __________________________ (date)

Consumer's name(s): ________________________________________

Consumer's email: ________________________________________

Signature (only if this form is notified on paper):
________________________________________

Date: __________________________

(*) Delete as appropriate.`}
    </div>

    <h2 className="mt-12">Important reminders</h2>
    <ul>
      <li><strong>3-Day Online Training:</strong> 10 days from signature of your training contract, by registered letter to the address stated in your contract. If your contract was concluded at a distance, you can also withdraw by email within 14 days. Nothing is paid before the end of the 10 days.</li>
      <li><strong>Mentorship and other services:</strong> 14 calendar days from purchase, by email, without giving any reason. If you requested the service to start within the 14 days, you will owe the proportion of the service already provided if you withdraw after it has started; once the service has been fully performed, the right of withdrawal is lost.</li>
      <li>Refunds are made using the same means of payment as the original transaction, within 14 days of receipt of your withdrawal notice.</li>
      <li>Full terms are set out in our <a href="/legal/terms">General Terms of Sale</a>.</li>
    </ul>
  </LegalLayout>
);

export default WithdrawalFormPage;
